import React, { useState, useCallback, useEffect, useRef } from 'react';
import useApi from '../../api/useApi';

function ProvisionDraggedGW({ handleClose, zones, openProvisionGW, address, refreshList }) {
  const orgId = JSON.parse(sessionStorage.user).organization.id;
  const { userId } = JSON.parse(sessionStorage.user).user;

  const formModel = {
    gatewayType: '',
    zoneId: '',
    longitude: '',
    latitude: '',
    attributes: null,
    createdBy: userId,
  };

  const [formData, setFormData] = useState(formModel);
  const [device, setDevices] = useState([]);

  const [{ isLoading, isError, data }, postData] = useApi();
  const [deviceRes, getDevice] = useApi();

  useEffect(() => {
    if (!deviceRes.isLoading && !deviceRes.isError && deviceRes.data) {
      const deviceArray = deviceRes.data.devices.filter(
        (data) =>
          data?.deviceType === 'BLE_GW' ||
          data?.device?.deviceType === 'BLE_GW' ||
          data?.deviceType === 'PHONE_GW' ||
          data?.device?.deviceType === 'PHONE_GW'
      );
      setDevices(deviceArray);
    }
  }, [deviceRes]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const body = {
      ...formData,
      deviceId: formData.deviceId,
      floorPlan: JSON.stringify({ x: openProvisionGW.x, y: openProvisionGW.y }),
      latitude: address?.latitude,
      longitude: address?.longitude,
    };

    // console.log(body);
    postData(`/device/${formData.deviceId}/gateway`, 'POST', body);
  };

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      //   notification('success', `Gateway provisioned successfully`);
      handleClose();
      refreshList();
    }
    if (isError) {
      //   notification('error', data);
      //   handleClose();
      // refreshList(s);
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    getDevice(`/organization/${orgId}/devices?deviceType=BLE_GW&isActive=false`, 'GET');
  }, []);

  const handleInputChange = useCallback((e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  });

  return (
    <div
      className="flex justify-center items-center h-full w-full fixed z-20"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
    >
      <div className="bg-white w-2/4  pt-1 relative rounded-2xl mobile_toggle">
        <img
          src="assets/img/Close.svg"
          className="absolute top-6 right-6 h-3 cursor-pointer"
          alt=""
          onClick={handleClose}
        />
        <p className="font-bold text-sm text-textBlue1 border-b p-4 pl-6">Provision Gateway</p>

        <form className="mt-2 mb-2 mx-10 grid grid-cols-2 gap-x-8 " onSubmit={handleSubmit} autoComplete="off">
          <div className="mt-5 w-full relative ">
            <div className="px-4 py-2 focus:outline-none inputLabelText">
              <select
                value={formData.deviceId}
                autoComplete="off"
                name="deviceId"
                required
                readOnly="readonly"
                className="border-none w-full focus:outline-none text-sm text-parameter border "
                onChange={handleInputChange}
              >
                <option value="">Select Gateway</option>
                {device.map((item) => (
                  <option key={item?.device ? item?.device?.id : item?.id}>
                    {item?.device ? item?.device?.id : item?.id}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="mt-5 w-full relative">
            <div className="px-4 py-2 focus:outline-none inputLabelText">
              <select
                value={formData.gatewayType}
                name="gatewayType"
                autoComplete="off"
                required
                className="border-none w-full focus:outline-none text-sm text-parameter border "
                onChange={handleInputChange}
              >
                <option value="">Select Gateway Type</option>
                <option value="BLE_GW">GENERIC</option>
                <option>ANDROID</option>
                <option>IOS</option>
                <option>LAIRD</option>
                <option>MERAKI</option>
                <option>MOBILOGIX</option>
                <option>QUUPPA</option>
                <option>ROAMBEE</option>
                <option>SYSTECH</option>
              </select>
            </div>
          </div>

          <div className="mt-5 w-full relative">
            <div className="px-4 py-2 focus:outline-none inputLabelText">
              <select
                name="zoneId"
                autoComplete="off"
                required
                className="border-none w-full focus:outline-none text-sm text-parameter border "
                onChange={handleInputChange}
              >
                <option value="">Select Zone</option>
                {zones.map((x) => (
                  <option value={x.id} key={x.id}>
                    {x?.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div></div>

          <div className="mt-5 w-full relative">
            <p className="font-bold px-4 py-2 focus:outline-none">{`X: ${openProvisionGW.x}`}</p>
          </div>
          <div className="mt-5 w-full relative">
            <p className="font-bold px-4 py-2 focus:outline-none">{`Y: ${openProvisionGW.y}`}</p>
          </div>

          <div className="w-1/2 mt-5 mb-2 relative ml-auto col-span-2">
            {/* {isLoading ? (
              <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto bottom-0" alt="" />
            ) : ( */}
            <div className="flex text-xs">
              <button
                type="submit"
                onClick={() => handleClose()}
                className="rounded-3xl w-1/2  border focus:outline-none  h-10 mr-3 cursor-pointer "
                // style={{ border: '1px solid #16406D' }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="rounded-3xl w-1/2 focus:outline-none h-10 text-white bg-primary cursor-pointer "
                style={{ border: '1px solid #16406D' }}
              >
                Save
              </button>
            </div>
            {/* )} */}
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProvisionDraggedGW;
